import React, { useState } from 'react';
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer } from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from './DateRangeFilter';
import { ReportWaitTimes } from '../../../api';

const WaitTimesReport = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [data, setData] = useState(null);

  const run = () =>
    ReportWaitTimes(access?.org?.id, { start, end }).then(setData).catch(() => {});

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>Wait Times</Typography>
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run} />
      {data && (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Metric</TableCell>
                <TableCell align="right">Minutes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow><TableCell>Average Wait</TableCell><TableCell align="right">{data.avgWait ?? '—'}</TableCell></TableRow>
              <TableRow><TableCell>Median Wait</TableCell><TableCell align="right">{data.medianWait ?? '—'}</TableCell></TableRow>
              <TableRow><TableCell>Average Service</TableCell><TableCell align="right">{data.avgService ?? '—'}</TableCell></TableRow>
              <TableRow><TableCell>Total Visits</TableCell><TableCell align="right">{data.totalVisits ?? '—'}</TableCell></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default WaitTimesReport;
